const IST_OFFSET_MINUTES = 330;
const IST_OFFSET_SUFFIX = '+05:30';

const pad2 = (value) => String(value).padStart(2, '0');
const pad3 = (value) => String(value).padStart(3, '0');

export const toISTISOString = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    throw new RangeError('Invalid time value');
  }

  // Shift epoch time by IST offset and then read UTC fields to avoid locale variance.
  const istDate = new Date(date.getTime() + IST_OFFSET_MINUTES * 60 * 1000);

  const year = istDate.getUTCFullYear();
  const month = pad2(istDate.getUTCMonth() + 1);
  const day = pad2(istDate.getUTCDate());
  const hours = pad2(istDate.getUTCHours());
  const minutes = pad2(istDate.getUTCMinutes());
  const seconds = pad2(istDate.getUTCSeconds());
  const millis = pad3(istDate.getUTCMilliseconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${millis}${IST_OFFSET_SUFFIX}`;
};

export const installISTDatePatch = () => {
  if (Date.prototype.__invexisIstIsoPatched) {
    return;
  }

  Object.defineProperty(Date.prototype, '__invexisIstIsoPatched', {
    value: true,
    enumerable: false,
    configurable: false,
    writable: false,
  });

  Date.prototype.toISOString = function toISOStringIST() {
    return toISTISOString(this);
  };
};
